import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiTooltip(theme: Theme): MuiThemeComponentOverride<"MuiTooltip"> {
  return {
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
      styleOverrides: {
        arrow: {
          color: theme.palette.brand.grey[700].main,
        },
        tooltip: {
          backgroundColor: theme.palette.brand.grey[700].main,
          color: theme.palette.brand.white[300].main,
          fontSize: "0.75rem",
          padding: "0.5rem 1rem",
        },
      },
    },
  };
}
